import { render, staticRenderFns } from "./customPageAdd.vue?vue&type=template&id=55dd4416&"
import script from "./customPageAdd.vue?vue&type=script&lang=js&"
export * from "./customPageAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports